module.exports = __webpack_public_path__ + "img/sideicon4.b160b8f1.png";